import { render, staticRenderFns } from "./order_form.vue?vue&type=template&id=b23e2fc8&scoped=true&"
import script from "./order_form.vue?vue&type=script&lang=js&"
export * from "./order_form.vue?vue&type=script&lang=js&"
import style0 from "./order_form.vue?vue&type=style&index=0&id=b23e2fc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23e2fc8",
  null
  
)

export default component.exports